import axios from "axios";
import { BACKEND_URL } from "../constants/Constant";

const BASE_URL = `${BACKEND_URL}/wallet`;

const rechargeWallet = async (payload) => {
  try {
    const response = await axios.post(`${BASE_URL}/recharge`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error Recharging Wallet:", error);
    throw error;
  }
};

const getAllCredits = async (userId) => {
  try {
    const response = await axios.get(`${BASE_URL}/all-credits/${userId}`);
    return response;
  } catch (error) {
    console.error("Error fetching all credits: ", error);
    throw error;
  }
};

export { rechargeWallet, getAllCredits };